var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{staticClass:"c-nav-card",class:{
    'c-nav-card--new': _vm.navItem.new
  },attrs:{"to":_vm.navItem.linkUrl || '#'}},[(_vm.navItem)?[_c('div',{staticClass:"c-nav-card__wrapper",class:[
        'l-flex',
        'l-flex__nowrap',
        'u-overflow-hidden',
      ]},[_c('div',{staticClass:"c-nav-card__image-wrapper"},[(_vm.navItem.image && _vm.navItem.image.src)?_c('nuxt-img',_vm._b({staticClass:"c-nav-card__image"},'nuxt-img',_vm.$getImgOptions(_vm.navItem.image, {
            preset: 'nav-card',
            alt: _vm.navItem.title
          }),false)):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"c-nav-card__copy",class:[
          'u-overflow-hidden',
        ]},[_c('header',{staticClass:"c-nav-card__header",class:['t-heading-8']},[_vm._v("\n          "+_vm._s(_vm.navItem.title)+"\n        ")]),_vm._v(" "),(_vm.navItem.subtitle && _vm.navItem.subtitle.length > 0)?_c('header',{staticClass:"c-nav-card__subheader",class:{
            'c-nav-card__subheader--accent': _vm.navItem.highlightSubtitle,
            't-heading-13': true,
            't-heading-13--light': true,
            'u-margin-bottom-xx-small': true,
          }},[_vm._v("\n          "+_vm._s(_vm.navItem.subtitle)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.navItem.description)?_c('p',{staticClass:"c-nav-card__description u-margin-bottom-x-small",class:['t-heading-11', 't-paragraph-small—x-light']},[_vm._v("\n          "+_vm._s(_vm.navItem.description)+"\n        ")]):_vm._e()])])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }